import { originService } from '../services'

const state = {
  origins: [],
  origin: null
}

const getters = {
  findAll (state) {
    return state.origins
  },
  findAllAdmin (state) {
    const foundAt = state.origins.find(origin => origin.id === 'other')
    state.origins.splice(foundAt, 1)
    return state.origins
  },
  find (state) {
    return id => state.origins.find(origin => origin.id === id)
  },
  currentOrigin (state) {
    return state.origin
  }
}

const mutations = {
  getAll (state, origins) {
    origins.unshift({ id: 'other', label: 'Autre' })
    state.origins = origins
  },
  find (state, origin) {
    state.origin = origin
  },
  create (state, item) {
    const foundAt = state.origins.findIndex(origin => origin.id === item.id)
    if (foundAt === -1) {
      state.origins.push(item)
    }
  },
  update (state, { id, item }) {
    const foundAt = state.origins.findIndex(origin => origin.id === id)
    state.origins.splice(foundAt, 1, item)
  },
  delete (state, id) {
    const foundAt = state.origins.findIndex(origin => origin.id === id)

    if (foundAt !== -1) {
      state.origins.splice(foundAt, 1)
    }
  }
}

const actions = {
  findAll (context) {
    return originService.findAll()
      .then(response => {
        context.commit('getAll', response.data)
        return response
      })
  },
  find (context, originId) {
    return originService.find(originId)
      .then(response => {
        context.commit('find', response.data)
        return response
      })
  },
  create (context, origin) {
    context.dispatch('loader/startLoading', 'origin/create', { root: true })
    return originService.create(origin)
      .then(response => {
        context.dispatch('alert/success', `Création réussie de l'origine ${response.data.label}.`, { root: true })
        return response.data
      })
      .catch(() => {
        context.dispatch('alert/error', `Echec de la création de l'origine ${origin}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'origin/create', { root: true })
      })
  },
  update (context, { originId, origin }) {
    context.dispatch('loader/startLoading', 'origin/update', { root: true })
    return originService.update(originId, origin)
      .then(response => {
        context.dispatch('alert/success', `Mise à jour réussie de l'origine ${response.data.label}.`, { root: true })
        return response.data
      })
      .catch(() => {
        context.dispatch('alert/error', `Echec de la mise à jour de l'origine ${origin}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'origin/update', { root: true })
      })
  },
  delete (context, originId) {
    return originService.remove(originId)
      .then(() => {
        context.commit('delete', originId)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
